import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { ConfirmationService } from 'primeng/api';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { SyncProcessLogsErrorService } from 'app/modules/vehicle-inventory/services/table-management/syncProcessLogsError.service';

@Component({
    selector: 'app-sync-process-logs-error',
    templateUrl: './sync-process-logs-error.component.html',
    styleUrls: ['./sync-process-logs-error.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [SyncProcessLogsErrorService, ConfirmationService, UserTimePipe],
    standalone: false,
})
export class SyncProcessLogsErrorComponent
    extends EntityListComponent<Rest.InvSyncProcessLogsError>
    implements OnInit {

    @Input() selectedLog: Rest.InvSyncProcessLogs;

    constructor(
        syncProcessLogsErrorService: SyncProcessLogsErrorService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
    ) {
        super(
            syncProcessLogsErrorService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
        );
    }

    ngOnInit() {
        super.ngOnInit();
    }

    beforeLoad(): void {
        if (this.selectedLog) {
            this.paginationRequest.filters['syncProcessLogId'] = [this.selectedLog.id.toString()];
        }
    }

}